import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import useAppInfo from '../../../../hooks/appInfo.hook';
import { MbResponsiveSteper } from '../../../../components/MbResponsiveSteper';
import { useUser } from '../../../../contexts/user.context';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/styles';
import { androidSteps } from './androidSteps';
import WarningCard from '../../../../components/publish/WarningCard';
import { storeStatus } from '../../../../utils/constants';

export default function FirstPublish() {
  const { user } = useUser();
  const { appInfo } = useAppInfo();

  const isDisabled = appInfo?.storeStatus !== storeStatus.ACTIVE;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [steps, setSteps] = useState([])
  const [currentStep, setCurrentStep] = useState();

  function checkCurrentStep(stepsData) {
    const stepIndex = stepsData.findIndex(x => !x.completed);

    // Start with all steps closed if store is on trial and not mobile
    if (!isMobile && user?.store?.status === storeStatus.ON_TRIAL)
      return null;

    if (stepIndex !== -1) {
      setCurrentStep(stepIndex)
    } else {
      setCurrentStep(stepsData.length - 1)
    }
  }

  useEffect(() => {
    const stepsData = androidSteps.create(user?.store, appInfo);

    setSteps(stepsData);
    checkCurrentStep(stepsData);
  }, [user]);

  return (
    <Box paddingInline={isMobile ? 2 : 8} paddingTop={isMobile ? 4 : 8}>
      {isDisabled && (
        <Box mb={4}>
          <WarningCard
            marginY={0.1}
            content={<>
              Escolha um plano para seguir com a publicação do seu aplicativo <br /> <a href="/pricing"> Iniciar assinatura</a>
            </>}
          />
        </Box>
      )}

      <Typography variant='body1' align='justify'>
        A publicação do seu aplicativo é feita em {steps.length} etapas.
        Em cada uma delas, você encontrará um resumo com as orientações do que deve ser feito.
      </Typography>

      <Box marginTop={4} paddingBottom={8} sx={{ textAlign: 'justify' }}>
        <MbResponsiveSteper steps={steps} currentStepIndex={currentStep} />
      </Box>
    </Box>
  )
}